export const API_BASE_URL = "https://backend.tooffi.com";
export const PRODUCT_BASE_URL = "/product";
export const ACCOUNT_BASE_URL = "/accounts";
export const CHECKOUT_BASE_URL = "/checkout";
export const ORDER_BASE_URL = "/order";

export const SEARCH_DEBOUNCE_TIME = 300;

export const SERVER_PHASE = typeof window === "undefined";

export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || "";

export const IS_PROD = ENVIRONMENT === "prod";

export const APP_BASE_URL = IS_PROD
  ? "https://tooffi.com"
  : "https://stg.tooffi.com";

export const MAP_USER_LOCATION_COOKIE_NAME = "map_user_location";
